import React, { useState } from "react";
import DraggableItem from "./DraggableSectionItem";

export default function RearrangeSectionList({ rows , onDataReorder}) {
  const [dragId, setDragId] = useState();
  const [items, setItems] = useState(rows?.filter((value) => value.id > 0))

  const handleDrag = (ev) => {
    setDragId(ev.currentTarget.id);
  };

  const handleDrop = (ev) => {
    const dragItem = items.find((box) => box.id == dragId);
    const dropItem = items.find((box) => box.id == ev.currentTarget.id);

    const dragBoxOrder = dragItem.displayOrder;
    const dropBoxOrder = dropItem.displayOrder;

    const newItemState = items.map((item) => {
      if (item.id == dragId) {
        item.displayOrder = dropBoxOrder;
      }
      if (item.id == ev.currentTarget.id) {
        item.displayOrder = dragBoxOrder;
      }
      return item;
    });
    setItems(newItemState);
    onDataReorder(newItemState)
  };
  return (
    <div className="d-flex p-2">
      <div className="progress-stepper stepper-container MuiBox-root css-0">
        <div className="stepper-containers MuiBox-root css-0">
          <div className="MuiBox-root css-fg6w03 scroll-context">
            <div className="MuiStepper-root MuiStepper-horizontal MuiStepper-alternativeLabel css-10mg1vw-MuiStepper-root">
              {items
                .sort((a, b) => a.displayOrder - b.displayOrder)
                .map((box) => (
                  <DraggableItem
                  detail={box}
                    key={box.id}
                    boxColor={box.color}
                    boxNumber={box.id}
                    handleDrag={handleDrag}
                    handleDrop={handleDrop}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
